import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from 'pages/Home';
import NotFound from 'pages/NotFound';
import AppLayout from '../AppLayout';
import PamoforRoutes from './PamoforRoutes';
import PresforRoutes from './PresforRoutes';

// Import des composants communs
const PSFCProfil = React.lazy(() => import('pages/Connexion/PSFCProfil'));
const PSFCMenuprofil = React.lazy(() =>
  import('pages/Connexion/PSFCMenuprofil')
);
const PSFCReinitialisermdp = React.lazy(() =>
  import('pages/Connexion/PSFCReinitialisermdp')
);
const PSFCMdpoublie = React.lazy(() => import('pages/Connexion/PSFCMdpoublie'));
const PSFCSeconnecter = React.lazy(() =>
  import('pages/Connexion/PSFCSeconnecter')
);
const PSFCSignin = React.lazy(() => import('pages/Connexion/PSFCSignin'));
const PSFCProjets = React.lazy(() => import('pages/PSFCProjets'));

// Import des composants Admin
const AdminHomePage = React.lazy(() => import('pages/Admin/AdminHomePage'));
const User = React.lazy(() => import('pages/Admin/AdminHomePage'));
const AddUser = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Contract = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Certificat = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Setting = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Notification = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Corbeille = React.lazy(() => import('pages/Admin/AdminHomePage'));
const Ota = React.lazy(() => import('pages/Admin/AdminHomePage'));
const ErrorBoundary = React.lazy(() =>
  import('components/componentsPamofor/Error')
);
const PSFCHome = React.lazy(() => import('pages/PSFCHome'));
const APropos = React.lazy(() =>
  import('pages/Projets/DigiFor/Pamofor/APropos')
);

const PresforWrapper = () => {
  return <Routes>{PresforRoutes}</Routes>;
};
const ProjectRoutes = () => {
  return (
    <React.Suspense fallback={<>Chargement...</>}>
      <Router>
        <AppLayout>
          <Routes>
            {/* Routes communes */}
            <Route path="/" element={<PSFCHome />} />
            <Route path="*" element={<NotFound />} />

            {/* Routes d'authentification */}
            <Route path="/psfcprofil" element={<PSFCProfil />} />
            <Route path="/psfcmenuprofil" element={<PSFCMenuprofil />} />
            <Route
              path="/psfcreinitialisermdp"
              element={<PSFCReinitialisermdp />}
            />
            <Route path="/psfcmdpoublie" element={<PSFCMdpoublie />} />
            <Route path="/psfcseconnecter" element={<PSFCSeconnecter />} />
            <Route path="/psfcsignin" element={<PSFCSignin />} />
            <Route path="/psfcprojets" element={<PSFCProjets />} />
            <Route path="/about" element={<APropos />} />

            {/* Routes Admin */}
            <Route path="/admin" element={<AdminHomePage />} />
            <Route path="/user" element={<User />} />
            <Route path="/adduser" element={<AddUser />} />
            <Route path="/contract" element={<Contract />} />
            <Route path="/certificat" element={<Certificat />} />
            <Route path="/setting" element={<Setting />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/corbeille" element={<Corbeille />} />
            <Route path="/ota" element={<Ota />} />
            <Route path="/error" element={<ErrorBoundary />} />

            {/* Intégration des routes Pamofor */}
            {PamoforRoutes}

            {/* Intégration des routes Presfor */}
            {/* {PresforRoutes} */}
            <Route path="/presfor/*" element={<PresforWrapper />} />
          </Routes>
        </AppLayout>
      </Router>
    </React.Suspense>
  );
};

export default ProjectRoutes;
